import { render, staticRenderFns } from "./DNSTwister.vue?vue&type=template&id=9895176c&"
import script from "./DNSTwister.vue?vue&type=script&lang=js&"
export * from "./DNSTwister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports